export const CREATE_WISHLIST = /* GraphQL */ `
    mutation createWishlist($input: CreateWishlistInput!) {
        createWishlist(input: $input) {
            wishlist {
                id
                name
            }
        }
    }
`
